import BaseRepository from './base.repository';

class MedicationHomeRepository extends BaseRepository {
  constructor() {
    super('/haven');
  }

  findAllSchedule(conditions) {
    return this.client.get('/intake', conditions);
  }

  findAllOrder(conditions) {
    return this.client.get('/medication-dispensed/orders', conditions);
  }

  findAllPrescription(conditions) {
    return this.client.get(`/medication-order/prescriptions`, conditions);
  }

  findAllMedication(conditions) {
    return this.client.get(`/medication-dispensed/medications`, conditions)
  }
}

export default new MedicationHomeRepository();
